"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Users = void 0;
const client_1 = require("@arkecosystem/client");
class Users extends client_1.Resource {
    async index(query) {
        return this.sendGet("guardian/users", query);
    }
    async get(publicKey) {
        return this.sendGet(`guardian/users/${publicKey}`);
    }
    async userGroups(publicKey) {
        return this.sendGet(`guardian/users/${publicKey}/groups`);
    }
}
exports.Users = Users;
//# sourceMappingURL=users.js.map